import { render } from "./ProjectsCard.vue?vue&type=template&id=5256fc8d&scoped=true"
import script from "./ProjectsCard.vue?vue&type=script&lang=js"
export * from "./ProjectsCard.vue?vue&type=script&lang=js"

import "./ProjectsCard.vue?vue&type=style&index=0&id=5256fc8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5256fc8d"]])

export default __exports__